// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Figtree_135c6a', '__Figtree_Fallback_135c6a'","fontStyle":"normal"},"className":"__className_135c6a","variable":"__variable_135c6a"};